import { render, staticRenderFns } from "./ProductDropship.vue?vue&type=template&id=6411fe76&"
import script from "./ProductDropship.vue?vue&type=script&lang=js&"
export * from "./ProductDropship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports